import { render, staticRenderFns } from "./RealEstateDetailsSummary.vue?vue&type=template&id=caaf181a&"
import script from "./RealEstateDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./RealEstateDetailsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports